<div class="task-table-container">
  @if (loading) {
    <div class="table-loading-overlay" aria-live="polite" aria-busy="true">
      <div class="loading-content">
        <i class="pi pi-spin pi-spinner" style="font-size: 1.75rem" aria-hidden="true"></i>
        <p>Loading tasks…</p>
      </div>
    </div>
  }

  <div class="table-wrapper">
    <table class="task-table">
      <thead>
        <tr>
          @if (isColumnVisible('taskId')) {
            <th [style.width]="'80px'"
              class="sortable-th" (click)="sortByColumn('taskId')">
              ID <i [class]="getSortIconClass('taskId')" class="sort-icon"></i>
            </th>
          }
          @for (col of getVisibleColumns(); track col) {
            @if (col.field !== 'taskId') {
              <th [style.width]="col.width"
                class="sortable-th" (click)="sortByColumn(col.field)">
                {{ col.header }} <i [class]="getSortIconClass(col.field)" class="sort-icon"></i>
              </th>
            }
          }
        </tr>
        <tr class="filter-row">
          <!-- ID filter -->
          @if (isColumnVisible('taskId')) {
            <th>
              <input
                pInputText
                type="number"
                class="filter-input"
                [ngModel]="columnFilters['taskId']"
                (ngModelChange)="onColumnFilterInput('taskId', $event)"
                placeholder="#"
                />
              </th>
            }
            <!-- Column filters -->
            @for (col of getVisibleColumns(); track col) {
              @if (col.field !== 'taskId') {
                <th>
                  @switch (col.field) {
                    <!-- Name filter -->
                    @case ('name') {
                      <input
                        pInputText
                        type="text"
                        class="filter-input"
                        [ngModel]="columnFilters['name']"
                        (ngModelChange)="onColumnFilterInput('name', $event)"
                        placeholder="Filter name"
                        />
                      }
                      <!-- Priority filter -->
                      @case ('priority') {
                        <p-multiSelect
                          dropdownIcon="fa fa-caret-down"
                          class="filter-input"
                          [options]="priorities"
                          optionLabel="name"
                          optionValue="value"
                          [ngModel]="columnFilters['priority'] || []"
                          (onChange)="onColumnFilterInput('priority', $event.value)"
                          placeholder="All"
                          appendTo="body">
                        </p-multiSelect>
                      }
                      <!-- Status filter -->
                      @case ('status') {
                        <p-multiSelect
                          dropdownIcon="fa fa-caret-down"
                          class="filter-input"
                          [options]="statuses"
                          optionLabel="name"
                          optionValue="value"
                          [ngModel]="columnFilters['status'] || []"
                          (onChange)="onColumnFilterInput('status', $event.value)"
                          placeholder="All"
                          appendTo="body">
                        </p-multiSelect>
                      }
                      <!-- Assigned To filter -->
                      @case ('assignedToUserVO.lastName') {
                        <div class="filter-input user-filter-cell">
                          <app-user-search
                            [forSearchBar]="true"
                            [selectedUser]="columnFilters['assignedTo']"
                            (onUserSelected)="onUserFilterChange('assignedTo', $event)"
                            (onUserClearedEvent)="onUserFilterChange('assignedTo', null)"
                            [showCreateUser]="false">
                          </app-user-search>
                        </div>
                      }
                      <!-- Author (Created By) filter -->
                      @case ('createdByUserVO.lastName') {
                        <div class="filter-input user-filter-cell">
                          <app-user-search
                            [forSearchBar]="true"
                            [selectedUser]="columnFilters['createdBy']"
                            (onUserSelected)="onUserFilterChange('createdBy', $event)"
                            (onUserClearedEvent)="onUserFilterChange('createdBy', null)"
                            [showCreateUser]="false">
                          </app-user-search>
                        </div>
                      }
                      <!-- Requested By filter -->
                      @case ('requestedByUserVO.lastName') {
                        <div class="filter-input user-filter-cell">
                          <app-user-search
                            [forSearchBar]="true"
                            [selectedUser]="columnFilters['requestedBy']"
                            (onUserSelected)="onUserFilterChange('requestedBy', $event)"
                            (onUserClearedEvent)="onUserFilterChange('requestedBy', null)"
                            [showCreateUser]="false">
                          </app-user-search>
                        </div>
                      }
                      <!-- Due Date range -->
                      @case ('dateDue') {
                        <div class="date-range-filter">
                          <p-calendar
                            [ngModel]="columnFilters['dateDueRange']"
                            (ngModelChange)="onColumnFilterInput('dateDueRange', $event)"
                            selectionMode="range"
                            dateFormat="yy-mm-dd"
                            [showClear]="true"
                            placeholder="Start - End"
                            appendTo="body">
                          </p-calendar>
                        </div>
                      }
                      <!-- Followup Date range -->
                      @case ('dateToFollowup') {
                        <div class="date-range-filter">
                          <p-calendar
                            [ngModel]="columnFilters['dateFollowupRange']"
                            (ngModelChange)="onColumnFilterInput('dateFollowupRange', $event)"
                            selectionMode="range"
                            dateFormat="yy-mm-dd"
                            [showClear]="true"
                            placeholder="Start - End"
                            appendTo="body">
                          </p-calendar>
                        </div>
                      }
                      <!-- Created Date range -->
                      @case ('dateCreated') {
                        <div class="date-range-filter">
                          <p-calendar
                            [ngModel]="columnFilters['dateCreatedRange']"
                            (ngModelChange)="onColumnFilterInput('dateCreatedRange', $event)"
                            selectionMode="range"
                            dateFormat="yy-mm-dd"
                            [showClear]="true"
                            placeholder="Start - End"
                            appendTo="body">
                          </p-calendar>
                        </div>
                      }
                      <!-- Completed Date range -->
                      @case ('dateCompleted') {
                        <div class="date-range-filter">
                          <p-calendar
                            [ngModel]="columnFilters['dateCompletedRange']"
                            (ngModelChange)="onColumnFilterInput('dateCompletedRange', $event)"
                            selectionMode="range"
                            dateFormat="yy-mm-dd"
                            [showClear]="true"
                            placeholder="Start - End"
                            appendTo="body">
                          </p-calendar>
                        </div>
                      }
                      <!-- Default: no filter control -->
                      @default {
                        <span></span>
                      }
                    }
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (row of displayRows; track row) {
              <tr (click)="onTaskClick(row.task, $event)"
                (dblclick)="onTaskDoubleClick(row.task, $event)" (contextmenu)="openCm($event, gf, row.task)" class="table-row"
                [class.subtask-row]="row.level > 0" [style.--tree-level]="row.level">
                @if (isColumnVisible('taskId')) {
                  <td class="task-id-cell">
                    <div class="d-flex gap-2 tree-cell-wrapper" [class.tree-cell-child]="row.level > 0">
                      <div class="d-flex align-items-center tree-toggler-cell">
                        <span (click)="openCm($event, gf, row.task)">
                          <i class="pi pi-align-justify" aria-hidden="true" style="margin-left: 5px"></i>
                        </span>
                        @if (row.hasChildren) {
                          <button type="button" class="tree-toggler p-link"
                            (click)="toggleExpand(row.task.taskId); $event.stopPropagation()"
                            [attr.aria-expanded]="expandedParentIds.has(row.task.taskId)" title="{{ expandedParentIds.has(row.task.taskId) ? 'Collapse' : 'Expand' }}">
                            <i class="pi" [ngClass]="expandedParentIds.has(row.task.taskId) ? 'pi-angle-down' : 'pi-angle-right'"></i>
                          </button>
                        }
                        @if (!row.hasChildren && row.level === 0) {
                          <span class="tree-toggler-placeholder"></span>
                        }
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <div>
                          @if (row.level > 0) {
                            <i class="pi pi-sitemap subtask-icon" title="Sub-task"></i>
                          }
                        </div>
                        <div>
                          #{{ row.task.taskId }}
                        </div>
                      </div>
                    </div>
                  </td>
                }
                <!-- Date Due -->
                @if (isColumnVisible('dateDue')) {
                  <td class="task-dateDue-cell">
                    @if (row.task?.dateDue) {
                      <span>{{ row.task.dateDue | date:'MM/dd/yyyy' }}</span>
                    }
                    @if (!row.task?.dateDue) {
                      <span class="empty-cell">—</span>
                    }
                  </td>
                }
                <!-- Name -->
                @if (isColumnVisible('name')) {
                  <td class="task-name-cell">
                    <span class="task-name-content">
                      {{ row.task.name }}
                      @if (row.level > 0 && getParentTaskDisplayName(row.task)) {
                        <span class="parent-task-indicator clickable"
                          (click)="onParentTaskClick(row.task, $event)" [title]="'Click to open parent task'">
                          <i class="pi pi-arrow-up"></i>
                          {{ getParentTaskDisplayName(row.task) }}
                        </span>
                      }
                    </span>
                  </td>
                }
                <!-- Assigned To -->
                @if (isColumnVisible('assignedToUserVO.lastName')) {
                  <td class="task-assignedToUserVO-lastName-cell">
                    @if (row.task?.assignedTo) {
                      <span>{{ fullName(row.task.assignedTo) }}</span>
                    }
                    @if (!row.task?.assignedTo) {
                      <span class="empty-cell">—</span>
                    }
                  </td>
                }
                <!-- Hours Est To Complete -->
                <!-- <td *ngIf="isColumnVisible('hoursEstToComplete')" class="task-hoursEstToComplete-cell">
                <span *ngIf="task?.hoursEstToComplete !== null && task?.hoursEstToComplete !== undefined && task?.hoursEstToComplete !== ''">
                  {{ task.hoursEstToComplete }}
                </span>
                <span *ngIf="task?.hoursEstToComplete === null || task?.hoursEstToComplete === undefined || task?.hoursEstToComplete === ''" class="empty-cell">—</span>
              </td> -->
              <!-- Priority -->
              @if (isColumnVisible('priority')) {
                <td class="task-priority-cell">
                  <div class="inline-dropdown" (click)="togglePriorityDropdown(row.task, $event)">
                    <span class="priority-badge priority-{{ row.task.priority || 4 }}">
                      {{ getPriorityName(row.task.priority || 4) }}&nbsp;&nbsp;&nbsp;<i class="fa fa-caret-down inline-dropdown-caret"></i>
                    </span>
                  </div>
                  @if (openPriorityTaskId === row.task.taskId) {
                    <div
                      class="inline-dropdown-menu"
                      (click)="$event.stopPropagation()">
                      @for (p of priorities; track p) {
                        <div
                          class="inline-dropdown-item"
                          (click)="selectPriority(row.task, p.value, $event)">
                          {{ p.name }}
                        </div>
                      }
                    </div>
                  }
                </td>
              }
              <!-- Created By / Author -->
              @if (isColumnVisible('createdByUserVO.lastName')) {
                <td class="task-createdByUserVO-lastName-cell">
                  @if (row.task?.createdBy) {
                    <span>{{ fullName(row.task.createdBy) }}</span>
                  }
                  @if (!row.task?.createdBy) {
                    <span class="empty-cell">—</span>
                  }
                </td>
              }
              <!-- Requested By -->
              @if (isColumnVisible('requestedByUserVO.lastName')) {
                <td class="task-requestedByUserVO-lastName-cell">
                  @if (row.task?.requestedBy) {
                    <span>{{ fullName(row.task.requestedBy) }}</span>
                  }
                  @if (!row.task?.requestedBy) {
                    <span class="empty-cell">—</span>
                  }
                </td>
              }
              <!-- Status -->
              @if (isColumnVisible('status')) {
                <td class="task-status-cell">
                  <div class="inline-dropdown" (click)="toggleStatusDropdown(row.task, $event)">
                    <span class="status-badge status-{{ row.task.status || 0 }}">
                      {{ getStatusName(row.task.status || 0) }}&nbsp;&nbsp;&nbsp;<i class="fa fa-caret-down inline-dropdown-caret"></i>
                    </span>
                  </div>
                  @if (openStatusTaskId === row.task.taskId) {
                    <div
                      class="inline-dropdown-menu"
                      (click)="$event.stopPropagation()">
                      @for (s of statuses; track s) {
                        <div
                          class="inline-dropdown-item"
                          (click)="selectStatus(row.task, s.value, $event)">
                          {{ s.name }}
                        </div>
                      }
                    </div>
                  }
                </td>
              }
              <!-- Followup Date -->
              @if (isColumnVisible('dateToFollowup')) {
                <td class="task-dateToFollowup-cell">
                  @if (row.task?.dateToFollowup) {
                    <span>{{ row.task.dateToFollowup | date:'MM/dd/yyyy' }}</span>
                  }
                  @if (!row.task?.dateToFollowup) {
                    <span class="empty-cell">—</span>
                  }
                </td>
              }
              <!-- Created Date -->
              @if (isColumnVisible('dateCreated')) {
                <td class="task-dateCreated-cell">
                  @if (row.task?.dateCreated) {
                    <span>{{ row.task.dateCreated | date:'MM/dd/yyyy' }}</span>
                  }
                  @if (!row.task?.dateCreated) {
                    <span class="empty-cell">—</span>
                  }
                </td>
              }
              <!-- Completed Date -->
              @if (isColumnVisible('dateCompleted')) {
                <td class="task-dateCompleted-cell">
                  @if (row.task?.dateCompleted) {
                    <span>{{ row.task.dateCompleted | date:'MM/dd/yyyy' }}</span>
                  }
                  @if (!row.task?.dateCompleted) {
                    <span class="empty-cell">—</span>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    @if (totalRecords > 0) {
      <div class="pagination-container">
        <div class="pagination-info">
          <span>Showing {{ (currentPage * rowsPerPage) + 1 }} to {{ Math.min((currentPage + 1) * rowsPerPage, totalRecords)
          }} of {{ totalRecords }} tasks</span>
        </div>
        <div class="pagination-controls">
          <button class="pagination-btn" [disabled]="currentPage === 0" (click)="goToFirstPage()" title="First Page">
            <i class="pi pi-angle-double-left"></i>
          </button>
          <button class="pagination-btn" [disabled]="currentPage === 0" (click)="goToPreviousPage()" title="Previous Page">
            <i class="pi pi-angle-left"></i>
          </button>
          <span class="pagination-page-info">
            Page {{ currentPage + 1 }} of {{ totalPages }}
          </span>
          <button class="pagination-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToNextPage()"
            title="Next Page">
            <i class="pi pi-angle-right"></i>
          </button>
          <button class="pagination-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToLastPage()"
            title="Last Page">
            <i class="pi pi-angle-double-right"></i>
          </button>
          <select class="pagination-rows-select" [ngModel]="rowsPerPage" (ngModelChange)="onRowsPerPageChange($event)">
            <option [value]="25">25 per page</option>
            <option [value]="50">50 per page</option>
            <option [value]="100">100 per page</option>
            <option [value]="200">200 per page</option>
          </select>
        </div>
      </div>
    }

    @if (!loading && totalRecords === 0) {
      <div class="empty-state">
        <i class="pi pi-inbox"></i>
        <p>No tasks found</p>
      </div>
    }
    <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
  </div>

  <p-dialog header="Summary" [(visible)]="showOpenSummary" [style]="{width: '30vw'}">
    @if (taskApiData) {
      <app-task-summary [task]="taskApiData"></app-task-summary>
    }
  </p-dialog>